import { Component, Injector, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { PluginService } from '../../services/plugin.service';

@Component({
    selector: 'plugin-slot',
    templateUrl: './slot.component.html',
    styleUrls: ['./slot.component.scss'],
})
export class PluginSlotComponent implements OnInit {

    /**
     * The name of the slot.
     */
    @Input() public name: string;

    /**
     * The data that will be passed trough to the plugin.
     */
    @Input() public data;

    @Input() public columns: number | boolean = 1;

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    /**
     * The rendered component instance.
     */
    public plugins = [];

    /**
     * The PluginService instance.
     */
    protected pluginService: PluginService;

    constructor(protected injector: Injector) {
        this.pluginService = this.injector.get(PluginService);
    }

    ngOnInit() {
        this.pluginService.slot(this.name).listen().subscribe((event) => {
            if (event['add']) {
                const plugin = event['add'];

                this.plugins.push(plugin);

                this.sort();
            }

            if (event['remove']) {
                const plugin = event['remove'];

                this.plugins = this.plugins.filter((item) => {
                    return plugin.name !== item.name;
                });
            }
        });
    }

    private sort() {
        this.plugins.sort((a, b): any => {
            if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
            } else {
                return false;
            }
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/components/slot/slot.component.ts